import React, { FC } from 'react';
import { ScrollView } from 'react-native';
import { TABLE_NAMES } from '@v2/pages/common/constants/base.constants';
import ColorWrapper, { WithColor } from '@styles/colors';
import Operations from '@components/search/operations';
import { isWeb, searchDisplayMode } from '@helpers';
import { scale as initialScale } from '@components/frame';
import { PaginatedResponse } from '@interfaces/machines';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { font as initialFont } from '@styles/fonts';
import { OperationSearchItem } from '@interfaces/search';
import { useManageProductionOrderJobsContent } from './hooks/useManageProductionOrderJobsContent';

export interface ProductionOrderJobsContentProps extends WithColor {
  totalCount: number;
  isError: boolean;
  maxContentWidth: number;
  jobsApiCall: (() => Promise<PaginatedResponse<OperationSearchItem>>) | null;
  scale?: ScaleFunction;
  font?: typeof initialFont;
}

const ProductionOrderJobsContent: FC<ProductionOrderJobsContentProps> = ({
  totalCount,
  isError,
  C,
  maxContentWidth,
  jobsApiCall,
  scale = initialScale,
  font = initialFont,
}) => {
  const { jobs, isAllJobsSelected, tableTools, generateImageURL } = useManageProductionOrderJobsContent();

  const {
    apiRef,
    columnVisibilityModel,
    setColumnVisibilityModel,
    filter,
    setFilter,
    filterModel,
    setFilterModel,
    orderBy,
    setOrderBy,
    sortModel,
    setSortModel,
    oDataFilter,
    setODataFilter,
  } = tableTools;

  if (!isAllJobsSelected) return null;

  const OperationsContent = (
    <Operations
      {...{
        withoutHorizontalPaddings: !isWeb,
        containerWidth: maxContentWidth - (isWeb ? 0 : scale(30)),
        totalSearchResult: totalCount,
        searchResult: jobs.data,
        isError,
        loaded: jobs.wasLoaded,
        C,
        search: () => {},
        isSmallMode: false,
        isLineMode: false,
        isInfoTilesMode: false,
        isTableMode: isWeb,
        displayMode: isWeb ? searchDisplayMode.tableStandard : searchDisplayMode.block,
        density: isWeb ? searchDisplayMode.tableStandard : searchDisplayMode.block,
        fetchData: jobsApiCall ? jobsApiCall : () => {},
        generateImageURL,
        recentlyViewed: [],
        setRecentlyViewed: () => {},
        facets: null,
        apiRef,
        setOrderBy,
        orderBy,
        sortModel,
        setSortModel,
        columnVisibilityModel,
        setColumnVisibilityModel,
        filter,
        setFilter,
        filterModel,
        setFilterModel,
        oDataFilter,
        setODataFilter,
        scale,
        font,
        tableName: TABLE_NAMES.productionOrderJobs,
      }}
    />
  );

  if (isWeb) {
    return OperationsContent;
  }

  return <ScrollView showsVerticalScrollIndicator={false}>{OperationsContent}</ScrollView>;
};

export default ColorWrapper(ProductionOrderJobsContent);
